import { useAuthQuery } from './useAuthQuery';
import { supabase } from '@/integrations/supabase/client';

export const useProjectsForSelect = () => {
  return useAuthQuery({
    queryKey: ['projects-for-select'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('id, project_name, company')
        .order('project_name');
      
      if (error) throw error;
      return data;
    },
    requiresAuth: true,
    requiresSession: true,
  });
};

// For Library module - excludes only inactive projects
export const useNonInactiveProjectsForSelect = () => {
  return useAuthQuery({
    queryKey: ['non-inactive-projects-for-select'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('id, project_name, company, status')
        .neq('status', 'inactive')
        .order('project_name');
      
      if (error) throw error;
      return data;
    },
    requiresAuth: true,
    requiresSession: true,
  });
};